import React from 'react';
import { Modal, Button } from "@forge/common";
import { CREATE_COURSE_CONSTANTS } from "../utils/constants";

interface CancelConfirmationModalProps {
    isOpen: boolean;
    isEditMode: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const CancelConfirmationModal: React.FC<CancelConfirmationModalProps> = ({
    isOpen,
    isEditMode,
    onClose,
    onConfirm
}) => {
    if (!isOpen) return null;

    return (
        <Modal
            backdrop={true}
            className="cancel-confirmation-modal border border-[#E0E0E0] border-[0.2px]"
            footerLeft={
                <div className="flex justify-center">
                    <Button
                        className="cancel-modal-btns mr-4 w-full"
                        id="confirm-cancel"
                        data-testid="confirm-cancel"
                        onClick={onClose}
                        size="regular"
                        variant="secondary"
                    >
                        {CREATE_COURSE_CONSTANTS.CANCEL_VM_MODAL.BUTTONS.NO}
                    </Button>
                    <Button
                        className="cancel-modal-btns w-full"
                        id="confirm-continue"
                        data-testid="confirm-continue"
                        onClick={onConfirm}
                        size="regular"
                        variant="primary"
                    >
                        {CREATE_COURSE_CONSTANTS.CANCEL_VM_MODAL.BUTTONS.YES}
                    </Button>
                </div>
            }
            onModalClose={onClose}
            title={
                isEditMode
                    ? CREATE_COURSE_CONSTANTS.CANCEL_VM_MODAL.UPDATE_TITLE
                    : CREATE_COURSE_CONSTANTS.CANCEL_VM_MODAL.CREATE_TITLE
            }
        >
            <div className="xl-low:!text-sm xl-mid:!text-base xl-high:!text-lg">
                {CREATE_COURSE_CONSTANTS.CANCEL_VM_MODAL.MESSAGE}
            </div>
        </Modal>
    );
};

export default CancelConfirmationModal;